import React from "react";
import { CheckCircle2, LinkIcon, PlusCircle } from "lucide-react";

const integrations = [
  {
    name: "Stripe",
    description: "Collect payments and manage subscriptions with Stripe.",
    icon: "https://cdn-icons-png.flaticon.com/512/5968/5968382.png",
    status: "connected",
    default: true,
  },
  {
    name: "Jobber",
    description: "Sync your scheduling and client management tools.",
    icon: "https://cdn-icons-png.flaticon.com/512/3144/3144456.png",
    status: "not_connected",
  },
  {
    name: "QuickBooks",
    description: "Automate accounting and manage invoices easily.",
    icon: "https://cdn-icons-png.flaticon.com/512/732/732220.png",
    status: "not_connected",
  },
  {
    name: "Google Sheets",
    description: "Export and sync your data directly to Google Sheets.",
    icon: "https://cdn-icons-png.flaticon.com/512/2991/2991148.png",
    status: "not_connected",
  },
];

const Integrations = () => {
  const otherIntegrations = integrations.filter((i) => !i.default);

  return (
    <div className="p-6 space-y-10">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-semibold text-gray-800 dark:text-white">
          Integrations
        </h1>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          Connect your favorite tools and manage your integrations here.
        </p>
      </div>

      {/* Default Integration */}
      <section>
        <h2 className="text-lg font-medium text-gray-700 dark:text-gray-300 mb-4">
          Default Integration
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div
              className="border border-green-400/30 dark:border-green-600/30 bg-white dark:bg-gray-800 rounded-2xl shadow-sm dark:shadow-gray-900/50 p-5 flex flex-col justify-between transition hover:shadow-md dark:hover:shadow-gray-900/70"
            >
              <div className="flex items-center space-x-4 mb-4">
                <img
                  src={"https://cdn-icons-png.flaticon.com/512/5968/5968382.png"}
                  alt="Stripe"
                  className="w-12 h-12 rounded-lg"
                />
                <div>
                  <h3 className="font-semibold text-gray-800 dark:text-white">Stripe</h3>
                  <p className="text-sm text-gray-500 dark:text-gray-400">Collect payments and manage subscriptions with Stripe.</p>
                </div>
              </div>

              <button
                className={`w-full flex items-center justify-center gap-2 py-2 rounded-lg text-sm font-medium transition bg-blue-600 hover:bg-blue-700 text-white`}
              >
              <LinkIcon className="w-4 h-4" />
              <a href={`https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${process.env.REACT_APP_STRIPE_CLIENT_ID}&scope=read_write&redirect_uri=${process.env.REACT_APP_STRIPE_REDIRECT_URL}`}>
                    Connect
              </a>
              </button>
            </div>
         
        </div>
      </section>

      {/* Other Integrations */}
      {/* <section>
        <h2 className="text-lg font-medium text-gray-700 dark:text-gray-300 mb-4">
          Other Integrations
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {otherIntegrations.map((item) => (
            <div
              key={item.name}
              className="border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 rounded-2xl shadow-sm dark:shadow-gray-900/50 p-5 flex flex-col justify-between transition hover:shadow-md dark:hover:shadow-gray-900/70"
            >
              <div className="flex items-center space-x-4 mb-4">
                <img
                  src={item.icon}
                  alt={item.name}
                  className="w-12 h-12 rounded-lg"
                />
                <div>
                  <h3 className="font-semibold text-gray-800 dark:text-white">{item.name}</h3>
                  <p className="text-sm text-gray-500 dark:text-gray-400">{item.description}</p>
                </div>
              </div>

              <button
                className={`w-full flex items-center justify-center gap-2 py-2 rounded-lg text-sm font-medium transition ${
                  item.status === "connected"
                    ? "border border-green-500 dark:border-green-600 text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-900/20 hover:bg-green-100 dark:hover:bg-green-900/30"
                    : "bg-blue-600 hover:bg-blue-700 text-white"
                }`}
              >
                {item.status === "connected" ? (
                  <>
                    <CheckCircle2 className="w-4 h-4" />
                    Connected
                  </>
                ) : (
                  <>
                    <PlusCircle className="w-4 h-4" />
                    Connect
                  </>
                )}
              </button>
            </div>
          ))}
        </div>
      </section> */}
    </div>
  );
};

export default Integrations;